import { render, staticRenderFns } from "./brokerChildren.vue?vue&type=template&id=78f76076&scoped=true&"
import script from "./brokerChildren.vue?vue&type=script&lang=js&"
export * from "./brokerChildren.vue?vue&type=script&lang=js&"
import style0 from "./brokerChildren.vue?vue&type=style&index=0&id=78f76076&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f76076",
  null
  
)

export default component.exports